export default "__VITE_ASSET__5b73737a__"